import { createOptionIn } from '../ui_utils/DomUtils.ts';
import { getProfilePopupElementId } from './UIViewProfilePopup.ts';
export class UIProfileRankedSeasonDropdownController {
    getSeasonDropdownElement() {
        const id = getProfilePopupElementId('profile_ranked_season_dropdown', this.isPopup);
        return document.getElementById(id);
    }
    fetchRankedDataForLatestSeason() {
        const latestSeason = this.seasons[0];
        this.profileRankedController.currentSeason = latestSeason.seasonType;
        void this.profileRankedController.fetchRankedDataForSelectedSeason(latestSeason.seasonType);
    }
    createDropdownOptions() {
        this.seasons.map((season)=>{
            createOptionIn(this.seasonDropdown, season.seasonType.toString(), season.name);
        });
    }
    createDropdownChangeEvent() {
        this.seasonDropdown.onchange = ()=>{
            const season = Number(this.seasonDropdown.value);
            void this.profileRankedController.fetchRankedDataForSelectedSeason(season);
        };
    }
    constructor(seasons, profileRankedController, isPopup = false){
        this.isPopup = isPopup;
        this.seasons = seasons;
        this.seasonDropdown = this.getSeasonDropdownElement();
        this.profileRankedController = profileRankedController;
        this.fetchRankedDataForLatestSeason();
        this.createDropdownOptions();
        this.createDropdownChangeEvent();
    }
}
